import { Box, Grid, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import GameService from '../../../../../services/game.service';
import GameStatsChart from './statChart';
import { getSeriesData } from '../../../../../common/utilities';
import GameStatsVideoPlayer from './videoDialog';

const GameStats = ({ game, t }) => {
    const [values, setValues] = useState({
        isOur: true,
        expandButtons: true,
        playerList: [],
        teamId: -1,
        opponentTeamId: -1,
        selectAll: false,
        clickEventName: ''
    });
    const [videoOpen, setVideoOpen] = useState(false);
    const [playData, setPlayData] = useState([]);
    const [refresh, setRefresh] = useState(false);

    const { user: currentUser } = useSelector((state) => state.auth);

    const handleChangeTeam = (flag) => {
        setValues({ ...values, isOur: flag, playerList: [] });
    };

    useEffect(() => {
        (async () => {
            if (values.playerList.length === 0) {
                if (values.teamId === -1 || values.opponentTeamId === -1) {
                    let team = 0;
                    let opponent = 0;

                    await GameService.getAllMyCoachTeam().then((res) => {
                        const filtered = res.filter(
                            (item) => item.season_name === game.season_name && item.league_name === game.league_name && (item.team_id === game.home_team_id || item.team_id === game.away_team_id)
                        );

                        team = filtered[0].team_id;
                        opponent = team === game.home_team_id ? game.away_team_id : game.home_team_id;
                    });
                    await GameService.getGamePlayerTags(currentUser.id, values.isOur ? team : opponent, null, `${game.id}`, null, null, null, null, null, null, null, null).then((res) => {
                        setValues({ ...values, teamId: team, opponentTeamId: opponent, playerList: getSeriesData(res) });
                    });
                } else {
                    await GameService.getGamePlayerTags(currentUser.id, values.isOur ? values.teamId : values.opponentTeamId, null, `${game.id}`, null, null, null, null, null, null, null, null).then(
                        (res) => {
                            setValues({ ...values, playerList: getSeriesData(res) });
                        }
                    );
                }
            }
        })();
    }, [values, refresh]);

  
    const getSum = (dataArr) => {
        var sm = 0;
        dataArr.map(e => {
            sm = sm + e
        })
        return sm;
    }

    const getList = (series) => {

        if (series) {
            const llst = []
            const slst = []
            const clst = []
            series.forEach(element => {
                if (element?.data > 0) {
                    llst.push(element.name)
                    slst.push(element.data)
                    clst.push(element.color)
                }
            });
            return { seriesDonut: slst, labelsLst: llst, colorLst: clst }
        }
    }

    function getPeriod(id) {
        return id === 1 ? 'H1' : id === 2 ? 'H2' : 'OT';
    }

    const handleClick = (data) => {
        try {
            const newData = data.map((item) => ({
                tag_id: item.id,
                start_time: item.player_tag_start_time,
                end_time: item.player_tag_end_time,
                player_name: item.player_names || item.player_name || item.full_name || '',
                action_name: item.action_names || item.action_name || '',
                action_type: item.action_type_names || item.action_type_name || item.action_type || '',
                action_result: item.action_result_names || item.action_result_name || item.action_result || '',
                game_id: item.game_id,
                team_id: values.teamId,
                court_area: item.court_area_id,
                inside_pain: item.inside_the_pain,
                period: item.period,
                time_in_game: item.time_in_game,
                home_team_logo: item.home_team_logo,
                away_team_logo: item.away_team_logo,
                home_team_goals: item.home_team_goals ?? item.home_team_goal,
                away_team_goals: item.away_team_goals ?? item.away_team_goal
            }));
            if (newData.length > 0) {
                setPlayData(newData)
                setVideoOpen(true)
            }
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <Box sx={{ width: '100%', background: '#f8fafc', overflowY: 'auto', padding: '12px 8px', gap: '10px', maxHeight: '79vh', minHeight: '77vh' }}>
            <Box
                sx={{
                    backgroundColor: '#ffffff',
                    borderRadius: '12px',
                    padding: '10px 20px',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                    marginBottom: '12px'
                }}
            >
                <Box sx={{ display: 'flex', gap: '4px' }}>
                    <Box
                        onClick={() => handleChangeTeam(true)}
                        sx={{
                            padding: '6px 16px',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            backgroundColor: values.isOur ? '#6366f1' : '#f3f4f6',
                            transition: 'all 0.15s ease',
                            '&:hover': {
                                backgroundColor: values.isOur ? '#6366f1' : '#e5e7eb'
                            }
                        }}
                    >
                        <Typography
                            sx={{
                                fontSize: '12px',
                                fontWeight: 600,
                                color: values.isOur ? '#ffffff' : '#6b7280'
                            }}
                        >
                            {t('Our Team')}
                        </Typography>
                    </Box>
                    <Box
                        onClick={() => handleChangeTeam(false)}
                        sx={{
                            padding: '6px 16px',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            backgroundColor: !values.isOur ? '#6366f1' : '#f3f4f6',
                            transition: 'all 0.15s ease',
                            '&:hover': {
                                backgroundColor: !values.isOur ? '#6366f1' : '#e5e7eb'
                            }
                        }}
                    >
                        <Typography
                            sx={{
                                fontSize: '12px',
                                fontWeight: 600,
                                color: !values.isOur ? '#ffffff' : '#6b7280'
                            }}
                        >
                            {t('Opponent')}
                        </Typography>
                    </Box>
                </Box>
            </Box>
            <Box
                sx={{
                    backgroundColor: '#ffffff',
                    borderRadius: '12px',
                    padding: '16px 20px',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.08)'
                }}
            >
            <Grid container spacing={2}>
                {values.playerList.map((stat, index) => (
                    stat.total > 0 && (
                        <Grid item xs={12} sm={6} key={index}>
                            <GameStatsChart
                                className="mb-3"
                                title={stat.title}
                                seriesBar={stat.seriesBar}
                                seriesDonut={getList(stat.seriesBar)}
                                total={stat.total}
                                tags={stat.tags}
                                handleClick={handleClick}
                                t={t}
                            />
                        </Grid>
                    )
                ))}
            </Grid>
            </Box>
            <GameStatsVideoPlayer
                t={t}
                open={videoOpen}
                onClose={(flag) => {
                    setVideoOpen(false);
                    if (flag) setRefresh((r) => !r);
                }}
                video_url={game.video_url}
                tagList={playData}
            />
        </Box>
    );
};

export default GameStats;
